export default defineNuxtPlugin(async nuxtApp => {
  const auth = useAuth();
  if (auth.loggedIn && auth.user && auth.user.language) {
    nuxtApp.$i18n.setLocale(auth.user.language);
  }
});
